import AbstractValidator from './AbstractValidator';

export default class StringLength extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        stringLengthInvalid: 'Die Eingabe ist ungültig, es wird ein Text erwartet',
        stringLengthTooShort: 'Die Länge der Eingabe beträgt weniger als %min% Zeichen.',
        stringLengthTooLong: 'Die Länge der Eingabe beträgt mehr als %max% Zeichen.',
    };

    run()
    {
        if ('string' !== typeof this.value)
        {
            this.error = this.getMessage('stringLengthInvalid');
            return;
        }

        let minLength = this._options.min;
        let maxLength = this._options.max;
        if (minLength && this.value.length < minLength)
        {
            this.error = this.getMessage('stringLengthTooShort');
        }
        else if (maxLength && this.value.length > maxLength)
        {
            this.error = this.getMessage('stringLengthTooLong');
        }
    }
}